import { useMutation } from '@tanstack/react-query';
import { loginDirect } from '@timetable/api';
import { useAuthStore } from '@/store/authStore';
import { useNavigate } from 'react-router-dom';
import type { LoginRequest } from '@timetable/types';

export function useLogin() {
  const navigate = useNavigate();
  const setAuth = useAuthStore((state) => state.setAuth);

  return useMutation({
    mutationFn: (credentials: LoginRequest) => {
      return loginDirect(credentials);
    },
    onSuccess: (data) => {
      // Block pending or rejected users from logging in
      const status = (data.user as any)?.status;
      if (status === 'pending') {
        throw new Error('Your account is pending admin approval. Please wait for an admin to approve your account.');
      }
      if (status === 'rejected') {
        throw new Error('Your account request was not approved. Please contact your school admin.');
      }

      // Store auth state in Zustand
      setAuth(
        data.user as any,
        data.session as any,
        data.user.role as any,
        data.user.school_id
      );

      // ALSO store session in localStorage in the format the API expects
      if (typeof window !== 'undefined' && data.session) {
        window.localStorage.setItem('supabase.auth.token', JSON.stringify({
          currentSession: {
            access_token: data.session.access_token,
            refresh_token: data.session.refresh_token,
            expires_at: data.session.expires_at,
            user: {
              id: data.user.id,
              email: data.user.email,
            }
          }
        }));
      }

      // Navigate based on role
      const userRole = data.user.role as string;
      if (userRole === 'teacher') {
        navigate('/teacher');
      } else if (userRole === 'super_admin') {
        navigate('/super-admin/schools');
      } else {
        navigate('/app/dashboard');
      }
    },
    onError: (error: Error) => {
      console.error('Login failed:', error);
    },
  });
}
